/**
 * The top row of a Sales Insights page: the "onsemble" wordmark on the left;
 * on the right, how fresh the data is, whose book this is, and which PCs the
 * numbers cover.
 */

import { useTranslation } from "react-i18next";
import { FreshLine } from "./FreshLine";

export function BrandHeader({
  asOf,
  repName,
  profitCenters,
}: {
  /** The date the data runs through */
  asOf: string | null;
  /** The signed-in rep, as Eclipse names them */
  repName?: string | null;
  /** The PCs the data covers, parent first; left out until known */
  profitCenters?: string[];
}) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-wrap items-center gap-x-6 gap-y-2 pt-5">
      {/* Wordmark: a brand mark, so it isn't translated */}
      <span className="text-si-xl font-bold tracking-[-0.03em]">onsemble</span>
      {/* Data date, then the rep's name and PC under it, at the right end, in grey */}
      <div className="ml-auto flex flex-col items-end gap-0.5 text-si-ink-3">
        <FreshLine asOf={asOf} />
        {/* Name and PC as Eclipse writes them, e.g. "Test Rep PC000"; left out when unknown */}
        {repName && <span className="text-si-sm">{repName}</span>}
        {/* "PC 352", or "PCs 163 · 164 · 165" for a parent with child PCs */}
        {profitCenters && profitCenters.length > 0 && (
          <span className="text-si-sm tabular-nums">
            {t(
              profitCenters.length === 1
                ? "pages.pcInsights.header.onePc"
                : "pages.pcInsights.header.manyPcs",
              { pcs: profitCenters.join(" · ") },
            )}
          </span>
        )}
      </div>
    </div>
  );
}
